import { Link } from "react-router";
import { Button, Card, EmptyState, Stack } from "@salesapp/ui";
import { useAccess } from "../../shell/AccessProvider";
import { useCrmHref } from "../../lib/customerUrl";

/**
 * Shown when a linked record cannot be loaded. One message covers deleted, wrong id and
 * no-permission so the page never reveals whether a record exists.
 */
export function RecordUnavailable({
  objectLabel,
  backTo,
  backLabel,
}: {
  objectLabel: string;
  backTo: string;
  backLabel: string;
}) {
  const { can } = useAccess();
  const crmHref = useCrmHref();
  const canRestore = can("crm.companies", "configure");
  return (
    <Card>
      <Stack gap={3}>
        <EmptyState
          title={`This ${objectLabel} is unavailable`}
          description={`This ${objectLabel} may have been deleted, or you may not have access to it.`}
        />
        <Stack gap={2}>
          <Link to={backTo}>
            <Button variant="secondary">{backLabel}</Button>
          </Link>
          {canRestore ? (
            <p className="crm-muted">
              Deleted records stay in the recycle bin for 30 days.{" "}
              <Link to={`${crmHref("/apps/crm/settings")}?tab=recycle`}>Open the recycle bin</Link>
            </p>
          ) : null}
        </Stack>
      </Stack>
    </Card>
  );
}
